import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-0 p-4 pb-0" }
const _hoisted_2 = { class: "col-12 py-2" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_4 = { class: "form-group pe-4 col-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "physician" }, " Physician ", -1 /* HOISTED */)
const _hoisted_6 = { class: "form-group col-7 mt-4" }
const _hoisted_7 = { class: "col-12 table-responsive-md table-responsive-sm table-responsive-lg" }
const _hoisted_8 = { class: "table border border-gray" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "First Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Work Phone"),
    /*#__PURE__*/_createElementVNode("th", null, "Fax Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Specialty"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1 /* HOISTED */)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_14 = ["colspan"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", null, "No Physicians Found.", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "table-error"
}
const _hoisted_18 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_EditPhysicianRow = _resolveComponent("EditPhysicianRow")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Physicians",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_TypeaheadInput, {
                placeholder: "Start Typing",
                getData: _ctx.getPhysicianList,
                value: _ctx.physiciansData,
                onValueChanged: _ctx.changePhysiciansData
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-md btn-primary px-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addPhysician()))
              }, "Add Physician")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            (_ctx.isLoading || _ctx.isError || !_ctx.hasData)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  _createCommentVNode(" LOADING "),
                  (_ctx.isLoading)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: i,
                          class: "table-loading"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                            return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_12))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" EMPTY "),
                  (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                        _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_16, 8 /* PROPS */, _hoisted_14)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" ERROR "),
                  (!_ctx.isLoading && _ctx.isError)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                        _createElementVNode("td", { colspan: _ctx.columns }, [
                          _createVNode(_component_ErrorMessageHandler, {
                            title: "Contact list",
                            "try-again": _ctx.getPhysician
                          }, null, 8 /* PROPS */, ["try-again"])
                        ], 8 /* PROPS */, _hoisted_18)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.physicians.items, (physician) => {
                  return (_openBlock(), _createElementBlock("tbody", {
                    key: physician.id
                  }, [
                    _createVNode(_component_EditPhysicianRow, {
                      physician: physician,
                      columns: _ctx.columns,
                      referral: _ctx.referral,
                      "refresh-list": _ctx.getPhysician,
                      "referral-id": _ctx.referralId
                    }, null, 8 /* PROPS */, ["physician", "columns", "referral", "refresh-list", "referral-id"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}